module.exports = __webpack_public_path__ + "img/dow_apple.6a6ca773.png";